import React, { useCallback } from 'react';
import List from 'core/modules/Partials/List/List';
import InfoBarSliderItem from './components/InfoBarSliderItem';

import './InfoBarSlider.scss';

function InfoBarSlider({
  offers, config, useAddToFavorite, carousel,
}) {
  const { tagHelper, shouldTrackInitialParams } = config;

  const handleRef = useCallback((ref) => {
    tagHelper(ref); // handle Chase tagging implementation
  }, []);

  return (
    <div className="mn_offersSliderWrapper" ref={handleRef}>
      <List shouldUseCarousel options={carousel}>
        {offers.map((offer) => (
          <InfoBarSliderItem
            useAddToFavorite={useAddToFavorite}
            offer={offer}
            config={offer.isDealOfTheWeek ? config.dealOfTheWeek : config.salesInfoBar}
            key={offer.id}
            shouldTrackInitialParams={shouldTrackInitialParams}
          />
        ))}
      </List>
    </div>
  );
}

export default InfoBarSlider;
